<script setup lang="ts">
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { DashboardGeneralSectionItem } from '../constants';
import { useInventoryDashboardStore } from '../pages/useInventoryDashboardStore';
import { storeToRefs } from 'pinia';
import { InventoryDashboardViewModel } from '../pages/inventoryDashboardViewModel';
const t = i18n.t;
const store = useInventoryDashboardStore();
const { state } = storeToRefs(store);
const vm = new InventoryDashboardViewModel();

const props = defineProps<{ item: DashboardGeneralSectionItem }>();
</script>
<template>
  <RouterLink
    :to="item.to"
    class="container"
    :class="props.item.valueKey.length > 1 ? 'container--multi-value' : 'container--single-value'"
  >
    <div class="title">
      <div class="title__inner">
        <div v-if="props.item.icon">
          <Mdi :icon="props.item.icon.name" :variant="props.item.icon.variant" :style="props.item.icon.style" />
        </div>
        <div class="title__text">{{ t(props.item.label) }}</div>
      </div>
      <div class="next-icon"><Mdi class="title__text" icon="arrow_forward" /></div>
    </div>
    <div>
      <div v-for="(value, index) in props.item.valueKey" :key="value" class="value">
        <div class="value__text">{{ vm.convertNumberToDisplayValue(value, state.overviewData[value]) }}</div>
        <div class="value__text--unit">{{ t(props.item.unit[index]) }}</div>
      </div>
    </div>
  </RouterLink>
</template>
<style lang="scss" scoped>
.container {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  align-content: space-between;
  background-color: $semanticWhite;
  border: 1px solid $borderDefault;
  border-radius: 8px;
  box-shadow: 0 0 22px 0px rgba(128, 128, 128, 0.4);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  &:hover {
    box-shadow: 0 2px 26px 0px rgba(128, 128, 128, 0.45);
    transform: translateY(-2px);
  }
  overflow: hidden;
  &--single-value {
    padding: 24px 16px 32px 16px;
  }
  &--multi-value {
    padding: 24px 16px 16px 16px;
  }
}
.title {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr max-content;
  justify-content: space-between;
  align-items: center;
  &__inner {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    min-width: 0;
    align-items: center;
    gap: 4px;
  }
  &__text {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.3;
    color: $textSecondary;
    min-width: 0;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
  }
}
.value {
  display: grid;
  grid-template-columns: max-content max-content;
  gap: 4px;
  align-items: end;
  &__text {
    font-weight: 700;
    font-size: 32px;
    line-height: 1.3;
    color: $textDefault;
    &--unit {
      font-weight: 400;
      font-size: 22px;
      line-height: 1.3;
      color: $textDefault;
    }
  }
}
</style>
